import React from 'react';
import './App.css';
import Main from "./components/Home/Main"
import Main2 from "./components/Home/Main2"
import Main3 from "./components/Home/Main3"
import Main4 from "./components/Home/Main4"


function App() {

  return (
    <div>
        <Main />
        <Main2/>
        <Main3/>
        <Main4/>
    </div>
  );
}

export default App;
